
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.5 8.5a4 4 0 11-.001 8.001A4 4 0 0112.5 8.5zm0 2v4m0 0L11 13m1.5 1.5L14 13M3.5 5.5v6h3"}}),_c('path',{attrs:{"d":"M3.5 9.5l1.793-1.793a1 1 0 011.414 0l.388.388a1 1 0 001.564-.193l.238-.4"}}),_c('path',{attrs:{"d":"M6 14.5H2.5a1 1 0 01-1-1v-11a1 1 0 011-1h7.086a1 1 0 01.707.293l1.914 1.914a1 1 0 01.293.707V6"}})])])
          )
        }
      }
    